import React from 'react';

// A card with a navy head: a small kicker over an Oswald title, and buttons on the right; then the body, and an
// optional grey foot. actions are { label, iconName, disabled, onClick }, drawn as light buttons that read on navy.
// The automatic invoicing setup shows its invoice in one.
export default function HeadedCard({ kicker = null, title = '', actions = [], foot = null, children = null }) {
  return (
    <div className='hcard'>
      <div className='hcard-head'>
        <div className='hcard-titles'>
          {kicker && <span className='hcard-kicker'>{kicker}</span>}
          <h3 className='hcard-title'>{title}</h3>
        </div>
        {actions.length > 0 && (
          <div className='hcard-actions'>
            {actions.map((action) => (
              <button
                key={action.label}
                type='button'
                className='hcard-button'
                disabled={action.disabled}
                onClick={action.onClick}
              >
                {action.iconName && (
                  <i
                    className={action.iconName}
                    aria-hidden='true'
                  />
                )}
                {action.label}
              </button>
            ))}
          </div>
        )}
      </div>
      <div className='hcard-body'>{children}</div>
      {foot && <div className='hcard-foot'>{foot}</div>}
    </div>
  );
}
